import { Component, OnInit } from '@angular/core';
import { Login } from './interfaces/Login';
import { UserRole } from './interfaces/UserRole';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { SetDeSet } from './components/set-deset';
import { Subscription } from 'rxjs';

///////////////////////////
/////////////////////////////////
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {slider } from './animations';
import { HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
//////////////////////////////////////////////////////////////////////////
import { trigger, state, style, transition, animate } from '@angular/animations';
/////////////////////////////////
//////////////////////////////////

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    //slider,
    /*
    trigger('slideInOut', [
      state('void', style({ transform: 'translateX(-100%)' })),
      state('*', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        animate('300ms ease-out')
      ]),
      transition('* => void', [
        animate('300ms ease-in')
      ])
    ])
      */

     trigger('backdropFade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 0.5 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0 }))
      ])
    ])

  ]
})
export class AppComponent implements OnInit{
 //@HostListener('window:beforeunload', ['$event'])

  /*
  handleClose($event) {


    $event.preventDefault;

      const conm = "\o/";
      localStorage.setItem('quizStatus', 'false');   
       

  }//handleClose ends here
  */

  /*

  @HostListener('window:beforeunload', ['$event'])
  handleClose(event: BeforeUnloadEvent) {
    event.preventDefault(); // ✅ must call it
    event.returnValue = ''; // ✅ required for most browsers to trigger confirmation
    const conm = "\\o/";    // ✅ escape backslash properly
    console.log(conm);
    window.localStorage.setItem('quizStatus', 'false');   
    window.localStorage.setItem('meetingStatus', 'false');
    alert('Window is closing. MeetingStatus set to false.');
  }
*/

 // @HostListener('window:load',['$event'])
 // onLoad($event) {
 //   const conm = "\o/";
  //  localStorage.setItem('quizStatus', 'false');
  //  console.log('is window:load');
  //}


  @HostListener('window:load', ['$event'])
  onLoad(event: Event) {    
    const conm = "\\o/";
    console.log('Window loaded', conm);
    window.localStorage.setItem('quizStatus', 'false');
    window.localStorage.setItem('meetingStatus', 'false');
    //alert('Window loaded. meetingStatus set to false.'); 
  }


  title = 'app';
  opened!: boolean; 
  //////////////////////////////////////
  //////////////////////////////////////////
  /////////////////////////////////////////
  mobileQuery!: MediaQueryList;

  fillerNav = Array(5).fill(0).map((_, i) => `Nav Item ${i + 1}`);

  fillerContent = Array(2).fill(0).map(() =>
    `Open side nav, and click on any navigation to close the opened side nav.`);

  private _mobileQueryListener!: () => void;
  ////////////////////////////////////////////////
  message!: boolean;
  subscription!: Subscription;

  //////////////////////////////////////////////////
  userDataSubscription: any;
  userData = new Login();
  userRole = UserRole;
  quizStatus = false;
  meetingStatus = false;
  //////////////////////////////////////////////////
  
  sidenavMode: 'side' | 'over' = 'side';
  isMobile = false;
  ////////////////////////////////

  constructor(private authService: AuthService, private uservice: UserService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,private setQ:SetDeSet,
    private breakpointObserver: BreakpointObserver)
   {

         this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        if (result.matches) {
          this.sidenavMode = 'over';   // overlay on mobile
          this.isMobile = true;
        } else {
          this.sidenavMode = 'side';   // fixed on desktop
          this.isMobile = false;
        }
      });


        if (localStorage.getItem('authToken')) {
          this.authService.setUserDetails();

          //////////////////////////////////
          ///////////////////////////////////
          this.mobileQuery = media.matchMedia('(max-width: 600px)');
          this._mobileQueryListener = () => changeDetectorRef.detectChanges();
          //this.mobileQuery.addListener(this._mobileQueryListener);
          this.mobileQuery.addEventListener('change', this._mobileQueryListener);

          /////////////////////////////////////
          /////////////////////////////////////
          

          
    }

    this.userDataSubscription = this.authService.userData.asObservable().subscribe(data => {
      this.userData = data;
    });


   // this.subscription = this.setQ.getMessage().subscribe(message => { this.message = message; });
  }

 

  ngOnInit() {

  //  localStorage.setItem('enrollId','0');
    localStorage.setItem('vdi', '0');
    localStorage.setItem('parsed', 'none');

    localStorage.setItem('tokStatus', 'Yes');
    const quizStatus=localStorage.getItem('quizStatus');
    this.quizStatus = Boolean(JSON.parse(quizStatus!));
      window.name = 'lmswindow';
    const meetingStatus=localStorage.getItem('meetingStatus');
    this.meetingStatus = Boolean(JSON.parse(meetingStatus!));
  
    //alert('ngOnInit. quizStatus set to '+ this.quizStatus + ' MeetingStatus set to '+ this.meetingStatus);
 
}


  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation']
  }

  checkAnnouncement() {
    if (this.userData.isLoggedIn && this.userData.role == this.userRole.User) {

    }
  }


  doBeforeUnload() {
    // Alert the user window is closing 
    alert('welcome');
  }

  doUnload() {
    // Clear session or do something
   // this.auth.getLogout();
    alert('bye');
  }

}
